// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app.less
// module id = ./resources/assets/less/app.less
// module chunks = 0